// src/components/LottieAnimation.js
import React, { useEffect, useRef } from 'react';
import lottie from 'lottie-web';
import confetti from './confetti.json';
import confetti2 from './confetti2.json';
import freeChipsPopUpSparkle from './freeChipsPopUpSparkle.json'
import check from './check.json'

const Lottie = ({ animationName, loop, className }) => {
  const animationRef = useRef( null )
  const animationInstance = useRef( null )

  let animation
  
  switch( animationName ) {
    case 'confetti':
      animation = confetti
      break;

    case 'confetti2':
      animation = confetti2
      break;

    case 'freeChipsPopUpSparkle':
      animation = freeChipsPopUpSparkle
      break;

    case 'check':
      animation = check
      break;
  }

  useEffect((  ) => {
    if( animationInstance && !animationInstance.current ){
      animationInstance.current = lottie.loadAnimation({
        container:  animationRef.current,
        renderer: 'svg',
        loop: loop,
        autoplay: true,
        animationData: animation,
      });
    }


    return () => {}
  }, [ animationInstance ]);

  return <div className={ className } ref={ animationRef } />;
};

export default Lottie;
